module.exports = __webpack_public_path__ + "img/quote.f6026ec3.webp";